var map = {
	"./": [
		316,
		9
	],
	"./Content": [
		1142,
		9,
		0,
		1,
		7,
		8,
		265,
		270
	],
	"./Content.dictionary": [
		1144,
		3,
		111
	],
	"./Content.dictionary.json": [
		1144,
		3,
		111
	],
	"./Content.jsx": [
		1142,
		9,
		0,
		1,
		8,
		265,
		276
	],
	"./ContentDeferred": [
		366,
		9
	],
	"./ContentDeferred.jsx": [
		366,
		9
	],
	"./InterestingMatches": [
		1024,
		9,
		23
	],
	"./InterestingMatches/": [
		1024,
		9,
		23
	],
	"./InterestingMatches/InterestingMatches.dictionary": [
		1040,
		3,
		126
	],
	"./InterestingMatches/InterestingMatches.dictionary.json": [
		1040,
		3,
		126
	],
	"./InterestingMatches/InterestingMatches.module.scss": [
		842,
		9,
		282
	],
	"./InterestingMatches/actions": [
		97,
		9
	],
	"./InterestingMatches/actions.ts": [
		97,
		9
	],
	"./InterestingMatches/components/Contetnt": [
		931,
		9,
		24
	],
	"./InterestingMatches/components/Contetnt/": [
		931,
		9,
		24
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary": [
		976,
		3,
		127
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": [
		976,
		3,
		127
	],
	"./InterestingMatches/components/Contetnt/Content.module.scss": [
		1039,
		9,
		283
	],
	"./InterestingMatches/components/Contetnt/index": [
		931,
		9,
		24
	],
	"./InterestingMatches/components/Contetnt/index.tsx": [
		931,
		9,
		24
	],
	"./InterestingMatches/components/Match": [
		848,
		9,
		25
	],
	"./InterestingMatches/components/Match/": [
		848,
		9,
		25
	],
	"./InterestingMatches/components/Match/Match.dictionary": [
		854,
		3,
		128
	],
	"./InterestingMatches/components/Match/Match.dictionary.json": [
		854,
		3,
		128
	],
	"./InterestingMatches/components/Match/index": [
		848,
		9,
		25
	],
	"./InterestingMatches/components/Match/index.tsx": [
		848,
		9,
		25
	],
	"./InterestingMatches/components/Sport": [
		975,
		9,
		129
	],
	"./InterestingMatches/components/Sport.tsx": [
		975,
		9,
		129
	],
	"./InterestingMatches/components/Stage": [
		880,
		9,
		130
	],
	"./InterestingMatches/components/Stage.tsx": [
		880,
		9,
		130
	],
	"./InterestingMatches/components/Tournament": [
		898,
		9,
		131
	],
	"./InterestingMatches/components/Tournament.jsx": [
		898,
		9,
		131
	],
	"./InterestingMatches/components/Union": [
		932,
		9,
		132
	],
	"./InterestingMatches/components/Union.jsx": [
		932,
		9,
		132
	],
	"./InterestingMatches/constants": [
		933,
		9,
		133
	],
	"./InterestingMatches/constants.ts": [
		933,
		9,
		133
	],
	"./InterestingMatches/index": [
		1024,
		9,
		23
	],
	"./InterestingMatches/index.jsx": [
		1024,
		9,
		23
	],
	"./InterestingMatches/reducer": [
		295,
		9
	],
	"./InterestingMatches/reducer/": [
		295,
		9
	],
	"./InterestingMatches/reducer/entities": [
		351,
		9
	],
	"./InterestingMatches/reducer/entities.js": [
		351,
		9
	],
	"./InterestingMatches/reducer/grid": [
		352,
		9
	],
	"./InterestingMatches/reducer/grid.js": [
		352,
		9
	],
	"./InterestingMatches/reducer/index": [
		295,
		9
	],
	"./InterestingMatches/reducer/index.js": [
		295,
		9
	],
	"./InterestingMatches/selectors": [
		834,
		9,
		26
	],
	"./InterestingMatches/selectors/": [
		834,
		9,
		26
	],
	"./InterestingMatches/selectors/entities": [
		275,
		9
	],
	"./InterestingMatches/selectors/entities.ts": [
		275,
		9
	],
	"./InterestingMatches/selectors/grid": [
		853,
		9,
		134
	],
	"./InterestingMatches/selectors/grid.ts": [
		853,
		9,
		134
	],
	"./InterestingMatches/selectors/index": [
		834,
		9,
		26
	],
	"./InterestingMatches/selectors/index.ts": [
		834,
		9,
		26
	],
	"./LandingPage.module.scss": [
		1185,
		9,
		284
	],
	"./MatchOfTheDay": [
		1025,
		9,
		1,
		8,
		27
	],
	"./MatchOfTheDay/": [
		1025,
		9,
		1,
		8,
		27
	],
	"./MatchOfTheDay/actions": [
		305,
		9
	],
	"./MatchOfTheDay/actions.ts": [
		305,
		9
	],
	"./MatchOfTheDay/components/Carousel": [
		977,
		9,
		1,
		8,
		28
	],
	"./MatchOfTheDay/components/Carousel/": [
		977,
		9,
		1,
		8,
		28
	],
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": [
		1143,
		9,
		285
	],
	"./MatchOfTheDay/components/Carousel/index": [
		977,
		9,
		1,
		8,
		28
	],
	"./MatchOfTheDay/components/Carousel/index.tsx": [
		977,
		9,
		1,
		8,
		28
	],
	"./MatchOfTheDay/components/MainStakes": [
		934,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/": [
		934,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": [
		1041,
		9,
		286
	],
	"./MatchOfTheDay/components/MainStakes/index": [
		934,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/index.tsx": [
		934,
		9,
		29
	],
	"./MatchOfTheDay/components/MatchTile": [
		978,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/": [
		978,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails": [
		1042,
		9,
		138
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": [
		1042,
		9,
		138
	],
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": [
		979,
		9,
		287
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": [
		1043,
		3,
		139
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": [
		1043,
		3,
		139
	],
	"./MatchOfTheDay/components/MatchTile/index": [
		978,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/index.tsx": [
		978,
		9,
		30
	],
	"./MatchOfTheDay/images/background.svg": [
		1199,
		1,
		288
	],
	"./MatchOfTheDay/images/pattern.svg": [
		1200,
		1,
		289
	],
	"./MatchOfTheDay/index": [
		1025,
		9,
		1,
		8,
		27
	],
	"./MatchOfTheDay/index.tsx": [
		1025,
		9,
		1,
		8,
		27
	],
	"./MatchOfTheDay/reducer": [
		353,
		9
	],
	"./MatchOfTheDay/reducer.ts": [
		353,
		9
	],
	"./MatchOfTheDay/selectors": [
		891,
		9,
		31
	],
	"./MatchOfTheDay/selectors/": [
		891,
		9,
		31
	],
	"./MatchOfTheDay/selectors/entities": [
		282,
		9
	],
	"./MatchOfTheDay/selectors/entities.ts": [
		282,
		9
	],
	"./MatchOfTheDay/selectors/grid": [
		922,
		9,
		140
	],
	"./MatchOfTheDay/selectors/grid.ts": [
		922,
		9,
		140
	],
	"./MatchOfTheDay/selectors/index": [
		891,
		9,
		31
	],
	"./MatchOfTheDay/selectors/index.ts": [
		891,
		9,
		31
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners": [
		1086,
		9,
		141
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": [
		1086,
		9,
		141
	],
	"./MiniBanners": [
		1026,
		9,
		0,
		32
	],
	"./MiniBanners/": [
		1026,
		9,
		0,
		32
	],
	"./MiniBanners/MiniBanners": [
		980,
		9,
		0,
		142
	],
	"./MiniBanners/MiniBanners.module.scss": [
		1044,
		9,
		290
	],
	"./MiniBanners/MiniBanners.tsx": [
		980,
		9,
		0,
		142
	],
	"./MiniBanners/components/Content": [
		899,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/": [
		899,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/Content": [
		881,
		9,
		0,
		143
	],
	"./MiniBanners/components/Content/Content.module.scss": [
		935,
		9,
		291
	],
	"./MiniBanners/components/Content/Content.tsx": [
		881,
		9,
		0,
		143
	],
	"./MiniBanners/components/Content/index": [
		899,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/index.ts": [
		899,
		9,
		0,
		33
	],
	"./MiniBanners/index": [
		1026,
		9,
		0,
		32
	],
	"./MiniBanners/index.ts": [
		1026,
		9,
		0,
		32
	],
	"./images/telegram.svg": [
		1201,
		1,
		333
	],
	"./index": [
		316,
		9
	],
	"./index.tsx": [
		316,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1265;
module.exports = webpackAsyncContext;